import classNames from "classnames";
import { useParams } from "react-router";
import { ModuleMap, PageModule, PageModuleType, Sponsor } from "../../../../types/working-model";
import { getStylingOverrides } from "../../utils";
import { ParamsProps } from "../../live-event";
import { SponsorsLayoutTypesClassic, TemplateClassNames } from "../../../../types/template-layouts";
import SponsorCard from './sponsor-card';
import './sponsors.scss';
import ReactMarkdown from "react-markdown";
import { TypographyItem } from "../../../general-ui/typography-item/typography-item";
import { getTextValue } from "../../../../utils/utils";
import React from 'react';

interface SponsorsProps {
	module: PageModule
	template: TemplateClassNames
}

const Sponsors = React.forwardRef<HTMLDivElement, SponsorsProps>(({ module, template }, ref) => {

	const { language }: ParamsProps = useParams();
	const { content, styling_overrides, modules } = module;
	const layout_type = content?.layout_type || SponsorsLayoutTypesClassic.standard;

	//init as one variable so it can be passed to the card
	const stylingOverrides = getStylingOverrides(styling_overrides);
	const {
		backgroundColor,
		backgroundImg,
		titleOverrides,
		descriptionOverrides,
		customHeadingOverrides
	} = stylingOverrides;

	const { custom_heading, description, title } = getTextValue(content, language);

	return module.is_on && content && (
		<section
			id={ModuleMap[PageModuleType.sponsors]}
			className={classNames(
				"sponsors",
				`sponsors-${layout_type}`,
				template,
				backgroundColor
			)}
			ref={ref}
		>
			<div className="module-container" style={backgroundImg}>
				<div className="sponsors-text-wrapper">
					<TypographyItem className={classNames('evt-caption-1 sponsors-custom-heading', customHeadingOverrides)}>
						{custom_heading}
					</TypographyItem>
					<TypographyItem className={classNames('evt-heading-2 sponsors-title', titleOverrides)} tagName="h2">
						{title}
					</TypographyItem>
					<TypographyItem className={classNames('evt-body-text-1 sponsors-description')}>
						<ReactMarkdown className={descriptionOverrides} source={description} />
					</TypographyItem>
				</div>
				<ul className="sponsor-cards-container">
					{modules?.map((sponsor: Sponsor) => {
						return <SponsorCard key={sponsor.sponsor} stylingOverrides={stylingOverrides} sponsor={sponsor} template={template} />;
					}) ?? []}
				</ul>
			</div>
		</section >
	);
});

Sponsors.displayName = 'Sponsors';

export default Sponsors;
